import React from 'react';

const Spinner = ({size="default"}) => {
    return(
        <div className={size==="default" ? "spinner" : "smallSpinner"}></div>
    );
};

export default Spinner;